import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../Auth.vue'
import Home from '../Home.vue'
import CustomerDetail from '../views/CustomerDetail.vue'
import History from '../views/History.vue'
import Merchant from '../views/Merchant.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'auth',
        component: Auth,
        props: true,
    },
    {
        path: '/',
        component: Home,
        children: [
            {
                path: '/history',
                name: 'history',
                component: History
            },
            {
                path: '/merchant',
                name: 'merchant',
                component: Merchant,
                meta: { requiresAuth: true }
            },
            {
                path: '/merchant/:branch_ref_no',
                name: 'merchant.history',
                component: History,
                props: true,
                meta: { requiresAuth: true }
            },
        ]
    },
    {
        path: '/customer-detail',
        name: 'customer-detail',
        component: CustomerDetail,
        props: true,
        meta: { requiresAuth: true }
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }

    {
        path: '/main-gonet',
        beforeEnter() {location.href = process.env.VUE_APP_MAIN_GONET_URL}
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
